module.exports = __webpack_public_path__ + "img/icon-terrible.a9ff27ae.svg";